import React, {Component} from 'react';
import {connect} from "react-redux";
import queryString from 'query-string'
import querystring from 'query-string'
import {Button, Col, Dropdown, Empty, Menu, Popover, Row, Spin, Typography} from 'antd';
import {
    updateAllGridsWBC,
    updatePageSizeWBC,
    updatePageWBCView,
    updateWBCSummary,
    updateZStackWrapperWBC,
    wbcChangeImage,
    wbcGridSelected
} from '../redux_actions/wbcview.action';
import {
    rbcChangeImage,
    rbcGridSelected,
    updateCurrentGrids,
    updateFetchingGridRBC,
    updatePageRBCView,
    updatePageSizeRBC,
    updateSelectedGridOverallId,
    updateTotalCountRBC,
    updateTotalPagesRBC
} from '../redux_actions/bloodGridRBC.action'
import {
    pltChangeImage,
    pltGridSelected,
    updateCurrGridsPLT,
    updateFetchingGridPLT,
    updatePagePLT,
    updatePageSizePLT,
    updateSelectedGridOverallIdPLT,
    updateTotalCountPLT,
    updateTotalPagesPLT
} from '../redux_actions/bloodGridPLT.action'
import {EditOutlined, LeftOutlined, RightOutlined,} from '@ant-design/icons';
import '../asset/style/workflow/tab-pane.css'
import {bloodClass} from '../utils/const'
import {convertSettingsToFilter, getBloodSecuredImageUrl, getStateAwareUrl, isNull, notNull} from "../utils/utils";
import {post} from "../helper/request";
import {FaInfoCircle, FaPen} from "react-icons/fa";
import cookie from "react-cookies";
import {store} from "../helper/store";
import {locateAnnotationOnMap} from "../component/gammaviewer/utils/map_utils";
import {markAnnotation} from "../component/gammaviewer/utils/annotations_app_utils";
import {notifyError, notifySuccess} from "../component/gammaviewer/utils/display.notification";

const {Text} = Typography;

export class BloodGridView extends Component {
    constructor(props) {
        super(props);

        this.gridRef = React.createRef();
        this.boxRef = React.createRef();

        this.state = {
            grid_data: [],
            page: 1,
            total_pages: '',
            total_count: '',
            first_time: false,
            dimensionChanged: false,
            spinning: false,
            first_time_redis: true,
            only_one_call: true,
            hover_grid_index: -1,

            imgdim: 0,
            tag_list: [],
            listannos: [],
        }
    }

    componentDidMount = () => {
        this.setGridSize();
    }

    firstSelectWBC = () => {
        if (this.state.grid_data.length === 0 && this.props.wbcGridData.all_grids.length === 0) {
            return;
        }

        let firstWbcData = this.state.grid_data.length === 0 ? this.props.wbcGridData.all_grids[0] : this.state.grid_data[0]

        let activeMapId = store.getState().gammaStateReducer.activeMapId;
        let slidemap = store.getState().mapsStateReducer[activeMapId].slidemap;
        markAnnotation(activeMapId, firstWbcData);
        locateAnnotationOnMap(slidemap, firstWbcData, true);


        store.dispatch(wbcChangeImage(true));
        store.dispatch(wbcGridSelected(firstWbcData));
        store.dispatch(updateZStackWrapperWBC(firstWbcData, this.props.fieldGridData.zStack))
        store.dispatch(updatePageWBCView(this.state.page))
    }

    firstSelectRBC = () => {
        store.dispatch(rbcChangeImage(true));
        store.dispatch(rbcGridSelected(this.state.grid_data[0]));
        store.dispatch(updateSelectedGridOverallId((this.state.grid_data[0] || {}).overall_count))
        store.dispatch(updatePageRBCView(this.state.page))
        store.dispatch(updateFetchingGridRBC(false));
    }

    firstSelectPLT = () => {
        store.dispatch(pltChangeImage(true));
        store.dispatch(pltGridSelected(this.state.grid_data[0]));
        store.dispatch(updateSelectedGridOverallIdPLT((this.state.grid_data[0] || {}).overall_count))
        store.dispatch(updatePagePLT(this.state.page))
        store.dispatch(updateFetchingGridPLT(false));
    }

    componentDidUpdate = (prevProps) => {


        if (this.state.dimensionChanged) {
            this.setGridSize()
            this.setState({dimensionChanged: false})
        }

        if (prevProps.page !== this.props.page) {
            if (this.props.page === '' || this.props.page === 0)
                this.onChangePage(1);
            else
                this.onChangePage(this.props.page)
        }
        if (notNull((document.getElementById('fieldimg_0') || {}).offsetWidth) && isNull(this.state.imgdim)) {
            this.setState({imgdim: (document.getElementById('fieldimg_0') || {}).offsetWidth})
        }
        //WBC
        if ((prevProps.wbcGridData || {}).tag !== (this.props.wbcGridData || {}).tag) {
            this.getGridData(1);
            this.setState({
                first_time: false,
            })
            this.onChangePage(1)
        }

        if (prevProps.bloodGridData.update_list !== this.props.bloodGridData.update_list) {
            this.getClassTag();
        }

        //RBC
        if (this.props.mode === bloodClass.RBC) {
            if (this.state.only_one_call &&
                this.props.rbcGridData.size_range_low !== -1 &&
                this.props.rbcGridData.size_range_high !== -1 &&
                this.props.rbcGridData.convexity_range_low !== -1 &&
                this.props.rbcGridData.convexity_range_high !== -1 &&
                this.props.rbcGridData.eccentricity_range_low !== -1 &&
                this.props.rbcGridData.eccentricity_range_high !== -1 &&
                this.props.rbcGridData.mean_color_range_low !== -1 &&
                this.props.rbcGridData.mean_color_range_high !== -1 &&
                this.props.rbcGridData.extreme_size_range_low !== -1 &&
                this.props.rbcGridData.extreme_size_range_high !== -1 &&
                this.props.rbcGridData.extreme_convexity_range_low !== -1 &&
                this.props.rbcGridData.extreme_convexity_range_high !== -1 &&
                this.props.rbcGridData.extreme_eccentricity_range_low !== -1 &&
                this.props.rbcGridData.extreme_eccentricity_range_high !== -1 &&
                this.props.rbcGridData.extreme_mean_color_range_low !== -1 &&
                this.props.rbcGridData.extreme_mean_color_range_high !== -1) {
                this.loadRedis(this.pageSize)
                this.setState({
                    only_one_call: false,
                })
            }


            if (this.state.first_time && (prevProps.rbcGridData.size_range_low !== this.props.rbcGridData.size_range_low ||
                prevProps.rbcGridData.size_range_high !== this.props.rbcGridData.size_range_high ||
                prevProps.rbcGridData.convexity_range_low !== this.props.rbcGridData.convexity_range_low ||
                prevProps.rbcGridData.convexity_range_high !== this.props.rbcGridData.convexity_range_high ||
                prevProps.rbcGridData.eccentricity_range_low !== this.props.rbcGridData.eccentricity_range_low ||
                prevProps.rbcGridData.eccentricity_range_high !== this.props.rbcGridData.eccentricity_range_high ||
                prevProps.rbcGridData.mean_color_range_low !== this.props.rbcGridData.mean_color_range_low ||
                prevProps.rbcGridData.mean_color_range_high !== this.props.rbcGridData.mean_color_range_high ||
                prevProps.rbcGridData.extreme_size_range_low !== this.props.rbcGridData.extreme_size_range_low ||
                prevProps.rbcGridData.extreme_size_range_high !== this.props.rbcGridData.extreme_size_range_high ||
                prevProps.rbcGridData.extreme_convexity_range_low !== this.props.rbcGridData.extreme_convexity_range_low ||
                prevProps.rbcGridData.extreme_convexity_range_high !== this.props.rbcGridData.extreme_convexity_range_high ||
                prevProps.rbcGridData.extreme_eccentricity_range_low !== this.props.rbcGridData.extreme_eccentricity_range_low ||
                prevProps.rbcGridData.extreme_eccentricity_range_high !== this.props.rbcGridData.extreme_eccentricity_range_high ||
                prevProps.rbcGridData.extreme_mean_color_range_low !== this.props.rbcGridData.extreme_mean_color_range_low ||
                prevProps.rbcGridData.extreme_mean_color_range_high !== this.props.rbcGridData.extreme_mean_color_range_high)) {
                this.setState({
                    page: 1,
                })
                store.dispatch(updatePageRBCView(1))
                this.getGridData(1);
                this.loadRedis(this.pageSize);
                this.setState({
                    first_time: false,
                })
            }
        }

        //PLT
        if (this.props.mode === bloodClass.PLT) {
            if (this.state.only_one_call &&
                this.props.pltGridData.size_range_low !== -1 &&
                this.props.pltGridData.size_range_high !== -1 &&
                this.props.pltGridData.extreme_size_range_low !== -1 &&
                this.props.pltGridData.extreme_size_range_high !== -1) {
                this.loadRedis(this.pageSize)
                this.setState({
                    only_one_call: false,
                })
            }
            if (this.state.first_time && ((prevProps.pltGridData || {}).size_range_low !== (this.props.pltGridData || {}).size_range_low ||
                (prevProps.pltGridData || {}).size_range_high !== (this.props.pltGridData || {}).size_range_high ||
                (prevProps.pltGridData || {}).extreme_size_range_low !== (this.props.pltGridData || {}).extreme_size_range_low ||
                (prevProps.pltGridData || {}).extreme_size_range_high !== (this.props.pltGridData || {}).extreme_size_range_high)) {
                store.dispatch(updatePagePLT(1))
                this.getGridData(1);
                this.loadRedis(this.pageSize);
                this.setState({
                    page: 1,
                    first_time: false,
                })
            }
        }

    }

    getNoOfRows = (dim) => {
        let rows = Math.max(Math.min(8, Math.ceil(dim / 100)), 2);
        /* @Spandan - Getting only even no. of rows because antd supports 24 spans. */
        if (rows !== 3 && rows % 2 !== 0) {
            rows--;
        }
        return rows;
    }

    setGridSize = () => {
        let h = 1, w = 1;
        if (notNull(this.boxRef.current)) {
            h = (this.boxRef.current || {}).clientHeight;
            w = (this.boxRef.current || {}).clientWidth;
        }
        let noOfGrids = Math.max(Math.min(7, Math.floor(h / 80)), 1);
        let noOfImgPerGrid = this.getNoOfRows(w);
        this.noOfImgPerGrid = noOfImgPerGrid
        if (this.props.mode === bloodClass.WBC) {
            // Max 3 rows for WBC
            this.noOfImgPerGrid = noOfImgPerGrid = Math.min(3, noOfImgPerGrid)
            this.pageSize = noOfGrids * noOfImgPerGrid;
            store.dispatch(updatePageSizeWBC(this.pageSize))
        } else if (this.props.mode === bloodClass.PLT) {
            this.pageSize = noOfGrids * noOfImgPerGrid;
            store.dispatch(updatePageSizePLT(this.pageSize))
        } else if (this.props.mode === bloodClass.RBC) {
            this.pageSize = noOfGrids * noOfImgPerGrid;
            store.dispatch(updatePageSizeRBC(this.pageSize))
        }
        this.getGridData(this.state.page);
        if (this.props.mode === bloodClass.WBC) {
            this.getClassTag();
            this.setState({imgdim: (document.getElementById('fieldimg_0') || {}).offsetWidth});
        } else {
            this.loadRedis(this.pageSize);
        }
    }

    getClassTag = () => {
        let wbcClassTags = this.props.bloodGridData.update_list;
        for (let i = 1; i < wbcClassTags.length; i++) {
            if (wbcClassTags[i]['name'] !== 'All') {
                this.setState({
                    tag_list: [...this.state.tag_list, wbcClassTags[i]['name']]
                })
            }
        }
    }

    loadRedis = (pageSize) => {
        if (this.props.mode === bloodClass.RBC) {
            let rbcGridData = this.props.rbcGridData;
            let low = rbcGridData.size_range_low;
            let high = rbcGridData.size_range_high;
            if (rbcGridData.size_range_low === -1 && rbcGridData.size_range_high === -1) {
                low = rbcGridData.extreme_size_range_low;
                high = rbcGridData.extreme_size_range_high;
            }
            let val = {
                slide_id: this.props.slide_id,
                page_size: pageSize,
                size_filter: (!((rbcGridData.size_range_low === -1 && rbcGridData.size_range_high === -1) || (rbcGridData.size_range_low === rbcGridData.extreme_size_range_low && rbcGridData.size_range_high === rbcGridData.extreme_size_range_high))),
                size_range_low: low,
                size_range_high: high,
                convexity_filter: (!((rbcGridData.convexity_range_low === -1 && rbcGridData.convexity_range_high === -1) || (rbcGridData.convexity_range_low === rbcGridData.extreme_convexity_range_low &&
                    rbcGridData.convexity_range_high === rbcGridData.extreme_convexity_range_high))),
                convexity_range_low: rbcGridData.convexity_range_low,
                convexity_range_high: rbcGridData.convexity_range_high,
                eccentricity_filter: (!((rbcGridData.eccentricity_range_low === -1 && rbcGridData.eccentricity_range_high === -1) || (rbcGridData.eccentricity_range_low === rbcGridData.extreme_eccentricity_range_low &&
                    rbcGridData.eccentricity_range_high === rbcGridData.extreme_eccentricity_range_high))),
                eccentricity_range_low: rbcGridData.eccentricity_range_low,
                eccentricity_range_high: rbcGridData.eccentricity_range_high,
                mean_color_filter: (!((rbcGridData.mean_color_range_low === -1 && rbcGridData.mean_color_range_high === -1) || (rbcGridData.mean_color_range_low === rbcGridData.extreme_mean_color_range_low &&
                    rbcGridData.mean_color_range_high === rbcGridData.extreme_mean_color_range_high))),
                mean_color_range_low: rbcGridData.mean_color_range_low,
                mean_color_range_high: rbcGridData.mean_color_range_high,
                first_time: this.state.first_time_redis,
                filter: this.props.orderby
            }

            let url = `/api/load_redis_rbc_size/`
            post(url, queryString.stringify(val))
                .then(() => {
                    this.setState({
                        first_time_redis: false
                    })
                })
        } else if (this.props.mode === bloodClass.PLT) {
            let low = this.props.pltGridData.size_range_low;
            let high = this.props.pltGridData.size_range_high;
            if (this.props.pltGridData.size_range_low === -1 && this.props.pltGridData.size_range_high === -1) {
                low = this.props.pltGridData.extreme_size_range_low;
                high = this.props.pltGridData.extreme_size_range_high;
            }
            let val = {
                slide_id: this.props.slide_id,
                page_size: pageSize,
                size_filter: (!((this.props.pltGridData.size_range_low === -1 && this.props.pltGridData.size_range_high === -1) ||
                    (this.props.pltGridData.size_range_low === this.props.pltGridData.extreme_size_range_low &&
                        this.props.pltGridData.size_range_high === this.props.pltGridData.extreme_size_range_high))),
                size_range_low: low,
                size_range_high: high,
                first_time: this.state.first_time_redis,
                filter: this.props.orderby
            }
            let url = `/api/load_redis_plt/`
            post(url, queryString.stringify(val))
                .then(() => {
                    this.setState({
                        first_time_redis: false
                    })
                })
        }
    }

    getGridData = (page) => {

        let page_size = this.pageSize;
        if (this.props.mode === bloodClass.WBC) {
            this.setState({
                spinning: true,
            })

            if (this.props.wbcGridData.all_grids.length > 0 && this.props.wbcGridData.page < this.state.total_pages) {
                let begin = (page - 1) * page_size;
                let end = begin + page_size;
                let data = this.props.wbcGridData.all_grids.slice(begin, end);
                this.setState({
                    grid_data: data,
                    total_pages: Math.ceil(this.props.wbcGridData.all_grids.length / this.props.wbcGridData.page_size),
                    total_count: this.props.wbcGridData.all_grids.length,
                    spinning: false
                })
                if (!this.state.first_time) {
                    this.firstSelectWBC();
                    this.setState({
                        first_time: true
                    })
                }
            } else if (this.props.wbcGridData.tag === '' && this.props.wbcGridData.all_grids.length > 0 && this.props.wbcGridData.page <= this.state.total_pages) {
                let begin = (page - 1) * page_size;
                let end = begin + page_size;
                let data = this.props.wbcGridData.all_grids.slice(begin, end);
                this.setState({
                    grid_data: data,
                    total_pages: Math.ceil(this.props.wbcGridData.all_grids.length / this.props.wbcGridData.page_size),
                    total_count: this.props.wbcGridData.all_grids.length,
                    spinning: false
                })
                if (!this.state.first_time) {
                    this.firstSelectWBC();
                    this.setState({
                        first_time: true
                    })
                }
            } else {
                let val = {
                    slide_id: this.props.slide_id,
                    page: page,
                    page_size: page_size,
                    tag: this.props.wbcGridData.tag,
                    paginated: false,
                }
                let url = this.props.confused ? `/api/retrieve_wbc_annotation_confused/` : `/api/retrieve_wbc_annotation/`
                post(url, queryString.stringify(val)).then(res => {
                    let begin = (page - 1) * page_size;
                    let end = begin + page_size;
                    let data = res['data'].slice(begin, end);
                    this.setState({
                        grid_data: data,
                        total_pages: res['total_pages'],
                        total_count: res['count'],
                        spinning: false
                    })

                    let curr_grids = res['data']
                    let selected_grid_id = this.props.wbcGridData.selected_grid_overall_id
                    for (let i = 0; i < curr_grids.length && selected_grid_id !== ''; i++) {
                        if (curr_grids[i].overall_count === selected_grid_id) {
                            store.dispatch(wbcGridSelected(curr_grids[i]));
                        }
                    }
                    if (res['data'].length === 0) {
                        store.dispatch(wbcGridSelected(""));
                    }
                    if (res['data'].length > 0 && !this.state.first_time) {
                        store.dispatch(updateAllGridsWBC(res['data']));
                        this.firstSelectWBC()
                        this.setState({
                            first_time: true
                        })
                    }
                });
            }
        } else if (this.props.mode === bloodClass.RBC) {
            store.dispatch(updateFetchingGridRBC(true))
            let page_size = this.pageSize
            let rbcGridData = this.props.rbcGridData;
            let val = {
                slide_id: this.props.slide_id,
                page: page,
                page_size: page_size,
                size_filter: (!((rbcGridData.size_range_low === -1 && rbcGridData.size_range_high === -1) ||
                    (rbcGridData.size_range_low === rbcGridData.extreme_size_range_low &&
                        rbcGridData.size_range_high === rbcGridData.extreme_size_range_high))),
                size_range_low: rbcGridData.size_range_low,
                size_range_high: rbcGridData.size_range_high,
                convexity_filter: (!((rbcGridData.convexity_range_low === -1 && rbcGridData.convexity_range_high === -1) ||
                    (rbcGridData.convexity_range_low === rbcGridData.extreme_convexity_range_low &&
                        rbcGridData.convexity_range_high === rbcGridData.extreme_convexity_range_high))),
                convexity_range_low: rbcGridData.convexity_range_low,
                convexity_range_high: rbcGridData.convexity_range_high,
                eccentricity_filter: (!((rbcGridData.eccentricity_range_low === -1 && rbcGridData.eccentricity_range_high === -1) ||
                    (rbcGridData.eccentricity_range_low === rbcGridData.extreme_eccentricity_range_low &&
                        rbcGridData.eccentricity_range_high === rbcGridData.extreme_eccentricity_range_high))),
                eccentricity_range_low: rbcGridData.eccentricity_range_low,
                eccentricity_range_high: rbcGridData.eccentricity_range_high,
                mean_color_filter: (!((rbcGridData.mean_color_range_low === -1 && rbcGridData.mean_color_range_high === -1) ||
                    (rbcGridData.mean_color_range_low === rbcGridData.extreme_mean_color_range_low &&
                        rbcGridData.mean_color_range_high === rbcGridData.extreme_mean_color_range_high))),
                mean_color_range_low: rbcGridData.mean_color_range_low,
                mean_color_range_high: rbcGridData.mean_color_range_high,
                filter: this.props.orderby
            }
            let url = `/api/retrieve_grid_view_rbc_size/`
            post(url, queryString.stringify(val))
                .then(res => {
                    this.setState({
                        grid_data: res['data'],
                        total_pages: res['total_pages'],
                        total_count: res['count'],
                        parameter: "size",
                        increasing: true,
                    })
                    store.dispatch(updateTotalPagesRBC(res['total_pages']))
                    store.dispatch(updateTotalCountRBC(res['count']))
                    store.dispatch(updateCurrentGrids(res['data']))

                    let curr_grids = res['data']
                    let selected_grid_id = rbcGridData.selected_grid_overall_id
                    for (let i = 0; i < curr_grids.length && selected_grid_id !== ''; i++) {
                        if (curr_grids[i].overall_count === selected_grid_id) {
                            store.dispatch(rbcGridSelected(curr_grids[i]));
                        }
                    }
                    if ((res['data'] || {}).length === 0) {
                        store.dispatch(updateSelectedGridOverallId(""))
                        this.setState({
                            first_time: true,
                        })

                    }
                    if (res['data'].length > 0 && !this.state.first_time) {
                        this.firstSelectRBC();
                        store.dispatch(updateFetchingGridRBC(false));
                        this.setState({
                            first_time: true,
                        })
                    } else {
                        store.dispatch(updateFetchingGridRBC(false));
                    }
                })
        } else if (this.props.mode === bloodClass.PLT) {
            store.dispatch(updateFetchingGridPLT(true))
            let page_size = this.pageSize
            let val = {
                slide_id: this.props.slide_id,
                page: page,
                page_size: page_size,
                size_filter: (!((this.props.pltGridData.size_range_low === -1 && this.props.pltGridData.size_range_high === -1) ||
                    (this.props.pltGridData.size_range_low === this.props.pltGridData.extreme_size_range_low &&
                        this.props.pltGridData.size_range_high === this.props.pltGridData.extreme_size_range_high))),
                size_range_low: this.props.pltGridData.size_range_low,
                size_range_high: this.props.pltGridData.size_range_high,
                filter: this.props.orderby
            }
            let url = `/api/retrieve_grid_view_plt/`
            post(url, queryString.stringify(val))
                .then(res => {
                    this.setState({
                        grid_data: res['data'],
                        total_pages: res['total_pages'],
                        total_count: res['count']
                    })
                    store.dispatch(updateTotalPagesPLT(res['total_pages']))
                    store.dispatch(updateTotalCountPLT(res['count']))
                    store.dispatch(updateCurrGridsPLT(res['data']))

                    let curr_grids = res['data']
                    let selected_grid_id = this.props.pltGridData.selected_grid_overall_id
                    for (let i = 0; i < curr_grids.length && selected_grid_id !== ''; i++) {
                        if (curr_grids[i].overall_count === selected_grid_id) {
                            store.dispatch(pltGridSelected(curr_grids[i]));
                        }
                    }
                    if ((res['data'] || {}).length === 0) {
                        store.dispatch(updateSelectedGridOverallIdPLT(""))
                        this.setState({
                            first_time: true,
                        })

                    }
                    if (res['data'].length > 0 && !this.state.first_time) {
                        this.firstSelectPLT();
                        store.dispatch(updateFetchingGridPLT(false));
                        this.setState({
                            first_time: true,
                        })
                    } else {
                        store.dispatch(updateFetchingGridPLT(false));
                    }
                })
        }
    }

    handleMenuClick = (e, annotation) => {
        let new_tag = this.state.tag_list[e.key]
        let oot_id = annotation.oot_id
        let value = {
            "new_tag": new_tag,
            "oot_id": oot_id,
        }
        let url = '/api/updateOOT/'
        post(url, querystring.stringify(value))
            .then(() => {
                this.getGridData(this.state.page);
                store.dispatch(updateWBCSummary(true));
                notifySuccess('tagUpdate', 'Tag Updated Successfully')
                if (annotation.id === (this.props.selected || {}).id) {
                    if (this.props.selected.count >= this.props.selected.total_count) {
                        this.props.loadPrev(0);
                    } else {
                        this.props.loadNext(0);
                    }
                }
            })
            .catch(() => notifyError('tagUpdate', 'Tag Update Failed'));
    }

    handleMultipleAnnoChange = (e) => {
        let new_tag = this.state.tag_list[e.key]
        let all_ids = this.state.listannos
        let value = {
            "new_tag": new_tag,
            "oot_id_list": all_ids,
        }
        let url = '/api/updatemultipleOOT/'
        post(url, querystring.stringify(value))
            .then(() => {
                store.dispatch(updateWBCSummary(true));
                notifySuccess('tagUpdate', 'Tag Updated Successfully')
            })
            .catch(() => notifyError('tagUpdate', 'Tag Update Failed'));

        this.setState({
            listannos: []
        })

    }

    addHover = (idx) => {
        this.setState({
            hover_grid_index: idx,
        })
    }

    getAnnotationsInGridView = () => {
        let currentAnnotations = this.state.grid_data;
        let isMobile = cookie.loadAll().isMobile === 'true';
        let annotationsGridParent;
        let imgsPerCol = this.noOfImgPerGrid;
        let colSpan = parseInt(24 / imgsPerCol);
        let numRows = this.pageSize / imgsPerCol;
        let currentImgCount = 0;
        let annotationRow = [];
        let annotationsGrid = [];
        let tags, menu_items;

        if (this.props.mode === bloodClass.WBC) {
            tags = this.state.tag_list;
            menu_items = tags.map((tag, index) => {
                return <Menu.Item key={index}>{tag}</Menu.Item>
            })
        }

        if (currentAnnotations.length === 0) {
            return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={""}
                          className={'full-parent flex-center'} style={{margin: 0}}
            />
        }

        for (let index = 0; index < currentAnnotations.length; index += 1) {
            let annotation = currentAnnotations[index];
            let annotationDiv;

            let edit_tag = null;
            let content_popover = null;
            if (this.props.mode === bloodClass.WBC) {
                const menu = (
                    <Menu onClick={(e) => this.handleMenuClick(e, currentAnnotations[index])}>
                        {menu_items}
                    </Menu>
                )

                let content;
                if (this.props.mode === bloodClass.WBC) {
                    content = (
                        <div>
                            <span>{annotation?.class.toUpperCase()}</span>
                        </div>
                    )
                }

                if (this.props.mode === bloodClass.WBC && this.state.hover_grid_index === index && !isMobile) {
                    content_popover = <Popover placement="top" content={content} style={{
                        backgroundColor: "#03112c",
                        border: '0px',
                        borderColor: 'rgba(0,0,0,0)'
                    }} trigger="click">
                        <Button ghost={true} style={{
                            border: '0px',
                            position: 'absolute',
                            right: '8%',
                            top: '5%',
                            padding: 0,
                            zIndex: '1',
                            backgroundColor: 'rgba(0,0,0,0)'
                        }}>
                            <FaInfoCircle/>
                        </Button>
                    </Popover>
                }

                if (this.props.mode === bloodClass.WBC && this.props.wbcGridData.tag !== '' && !isMobile && this.state.hover_grid_index === index) {
                    edit_tag = <Dropdown overlay={menu} trigger="click" style={{
                        backgroundColor: 'rgba(0,0,0,0)',
                        border: '0px',
                        borderColor: 'rgba(0,0,0,0)'
                    }}>
                        <Button style={{
                            backgroundColor: 'rgba(0,0,0,0)',
                            zIndex: 1,
                            position: 'absolute',
                            border: '0px',
                            right: '8%',
                            bottom: '5%',
                            padding: 0,
                        }}>
                            <FaPen style={{color: 'white'}}/>
                        </Button>
                    </Dropdown>
                }

            }

            let filter = convertSettingsToFilter(this.props.cssfilter);

            annotationDiv = <Col key={currentImgCount} className={'full-height'} span={colSpan}
                                 onMouseEnter={() => {
                                     this.addHover(index)
                                 }}
                                 onMouseLeave={() => {
                                     !isMobile ? this.addHover(1) : this.addHover(index)
                                 }}
                                 onTouchStart={() => {
                                     this.onGridClicked(annotation);
                                     this.addHover(index);
                                 }}>
                <Row className={'full-parent flex-center'} style={{padding: '5%', height: '100%', width: '100%', display: 'flex'}}>
                    {this.props.mode === bloodClass.WBC ? content_popover : null}
                    {this.props.mode === bloodClass.WBC ? edit_tag : null}
                    <img
                        id={`fieldimg_${index}`}
                        alt={`fieldimg_${index}`}
                        key={`fieldimg_${index}${this.state.dimensionChanged}`}
                        className={`max-parent min-content imageDim`}
                        style={annotation.id === (this.props.selected || {}).id && this.state.listannos.includes(annotation.id) ? {
                                border: '3px solid #7CFC00',
                                outline: '4px solid #1cb2ba',
                                filter,
                            } :
                            annotation.id === (this.props.selected || {}).id ? {
                                filter,
                                border: "4px solid #7CFC00",
                                borderRadius: '0.5em'
                            } : this.state.listannos.includes(annotation.id) ? {
                                border: '6px solid #1cb2ba',
                                filter
                            } : {
                                borderRadius: '0.5em', filter
                            }}
                        src={getBloodSecuredImageUrl(annotation.thumbnail)}
                        onClick={() => {
                            this.onGridClicked(annotation)
                        }}
                        onLoad={() => {
                            document.getElementById('fieldimg_' + index).className = 'max-parent min-content';
                        }}
                        onError={() => {
                            document.getElementById('fieldimg_' + index).className = 'max-parent min-content';
                        }}
                    />
                </Row>
            </Col>

            if (currentImgCount === imgsPerCol) {
                annotationsGrid.push(<Row className={"full-width"} key={annotationsGrid.length}
                                          style={{height: `${100 / numRows}%`}}>{annotationRow}</Row>);
                annotationRow = [];
                currentImgCount = 0;
            }

            annotationRow.push(annotationDiv);
            currentImgCount++;
        }

        annotationsGrid.push(<Row className={"full-width"} key={annotationsGrid.length}
                                  style={{height: `${100 / numRows}%`}}>{annotationRow}</Row>);
        annotationsGridParent =
            <Row className={'full-parent full-parent-imp'} style={{padding: '0px 5px'}}>
                {annotationsGrid}
            </Row>

        return annotationsGridParent;
    }

    onChangePage = (p) => {
        if (this.props.mode === bloodClass.WBC) {
            store.dispatch(updatePageWBCView(p));
        } else if (this.props.mode === bloodClass.RBC) {
            store.dispatch(updatePageRBCView(p));
        } else if (this.props.mode === bloodClass.PLT) {
            store.dispatch(updatePagePLT(p));
        }
        this.setState({
            page: p,
        });
        this.getGridData(p);
    }

    selectMultiple = (annoid) => {
        let newlistannos = this.state.listannos
        if (newlistannos.includes(annoid.oot_id)) {
            const id = newlistannos.indexOf(annoid.oot_id);
            const removed = newlistannos.splice(id, 1);
        } else {
            newlistannos.push(annoid.oot_id)
        }
        this.setState({
            listannos: newlistannos
        })
    }

    onGridClicked = (annotation) => {

        if (this.props.mode === bloodClass.WBC) {
            if ((window.event.metaKey || window.event.ctrlKey) && this.props.wbcGridData.tag !== '') {
                this.selectMultiple(annotation);
            } else {
                store.dispatch(wbcChangeImage(true));
                store.dispatch(wbcGridSelected(annotation));
                store.dispatch(updateZStackWrapperWBC(annotation, this.props.fieldGridData.zStack));
                this.props.onSelect(annotation);
            }
        } else if (this.props.mode === bloodClass.PLT) {
            store.dispatch(pltChangeImage(true));
            store.dispatch(pltGridSelected(annotation));
            store.dispatch(updateSelectedGridOverallIdPLT(annotation.overall_count));
            this.props.onSelect(annotation);
        } else if (this.props.mode === bloodClass.RBC) {
            store.dispatch(rbcChangeImage(true));
            store.dispatch(rbcGridSelected(annotation))
            store.dispatch(updateSelectedGridOverallId(annotation.overall_count));
            this.props.onSelect(annotation);
        }
    }


    decreasepage = () => {
        let all_images = document.getElementsByTagName("img");
        for (let i = 0; i < all_images.length; i++) {
            if (all_images[i].className === 'max-parent imageBright' || all_images[i].className === 'max-parent') {
                all_images[i].className = 'max-parent imageDim';
            }
        }
        let curr = this.state.page;
        if (curr === 1) {
            return;
        }
        this.onChangePage(curr - 1);
    }

    increasepage = () => {
        let all_images = document.getElementsByTagName("img");
        for (let i = 0; i < all_images.length; i++) {
            if (all_images[i].className === 'max-parent imageBright' || all_images[i].className === 'max-parent') {
                all_images[i].className = 'max-parent imageDim';
            }
        }
        let curr = this.state.page;
        if (curr === this.state.total_pages) {
            return;
        }
        this.onChangePage(curr + 1);
    }

    render() {

        let annotationsGridParent = this.getAnnotationsInGridView()

        let selectCounter = null;
        if ((this.props.mode === bloodClass.RBC || this.props.mode === bloodClass.PLT) && this.props.selected) {
            selectCounter = <Text className={'full-parent flex-center'} style={{color: 'white'}}>
                #{(this.props.selected || {}).overall_count}
            </Text>
        }

        let gridNumber = null;
        if (this.state.total_count > 0) {
            if (this.state.page === '' || this.state.page === 0) {
                this.setState({page: 1});
            }
            gridNumber = <Row className={'full-parent'} style={{height:"100%"}}>
                <Col className={'full-height flex-center'} offset={2} span={2}>
                    <Button className={'strip-button-blood'} onClick={this.decreasepage}
                            disabled={this.state.page === 1}>
                        <LeftOutlined style={{color: 'cyan', fontSize: '20px'}}/>
                    </Button>
                </Col>
                <Col className={'full-height'} span={16}>
                    <Text className={'full-parent flex-center'} style={{color: 'white'}}>
                        {`${((this.state.page - 1) * this.pageSize) + 1}-${Math.min((this.state.page * this.pageSize), this.state.total_count)} of ${this.state.total_count}`}
                    </Text>
                </Col>
                <Col className={'full-height flex-center'} span={2}>
                    <Button className={'strip-button-blood'} onClick={this.increasepage}
                            disabled={this.state.page >= this.state.total_pages}>
                        <RightOutlined style={{color: 'cyan', fontSize: '20px'}}/>
                    </Button>
                </Col>
                <Col className={'full-height'} span={1}>
                    {selectCounter}
                </Col>
            </Row>
        }

        let tags = this.state.tag_list;
        let menu_items = tags.map((tag, index) => {
            return <Menu.Item key={index}>{tag}</Menu.Item>
        })

        const menuSingle = (
            <Menu onClick={(e) => this.handleMenuClick(e, this.props.selected)}>
                {menu_items}
            </Menu>
        )

        const menuMultiple = (
            <Menu onClick={(e) => this.handleMultipleAnnoChange(e)}>
                {menu_items}
            </Menu>
        )

        let contentinfo = null;
        if (this.props.mode === bloodClass.WBC && this.props.selected && this.props.selected.class) {
            contentinfo = (
                <div>
                    <span style={{color: 'white'}}>{this.props.selected.class.toUpperCase()}</span>
                </div>
            )
        }

        let editMobile = null;
        if (cookie.loadAll().isMobile === 'true' && this.props.selected !== '') {
            if ((this.props.wbcGridData || {}).tag !== '') {
                editMobile = <><Dropdown overlay={menuSingle} trigger="click"
                                         style={{backgroundColor: 'rgba(0,0,0,0)', position: 'absolute', zIndex: 3}}>
                    <Button style={{
                        backgroundColor: 'rgba(255,255,255,0.8)',
                        position: "absolute",
                        border: '0px solid black',
                        marginTop: '-8.5vh',
                        marginLeft: (this.state.imgdim / 2),
                        width: this.state.imgdim * 1.3,
                        height: '3vh',
                        fontWeight: "bold"
                    }}>
                        <span style={{textAlign: "center", fontSize: '0.9vw', height: 'inherit'}}>ASSIGN<EditOutlined
                            style={{color: "black",}}/></span> </Button>
                </Dropdown>
                    <Typography style={{
                        fontSize: '1vw', backgroundColor: 'rgba(255,255,255,0)', position: "absolute", border: '0px',
                        textAlign: 'center', height: '3vh', marginTop: '-8vh', marginLeft: (this.state.imgdim * 2)
                    }}>
                        {contentinfo}
                    </Typography></>
            } else {
                editMobile = <Typography style={{
                    fontSize: '1vw', backgroundColor: 'rgba(255,255,255,0)', position: "absolute", border: '0px',
                    textAlign: 'center', height: '3vh', marginTop: '-3.5vh', marginLeft: (this.state.imgdim * 1.4)
                }}>
                    {contentinfo}
                </Typography>
            }
        }

        let editMultiple = null;
        if (this.state.listannos.length !== 0) {
            editMultiple = <Dropdown overlay={menuMultiple} trigger="click" style={{
                backgroundColor: 'rgba(0,0,0,0)',
                position: 'absolute',
                marginTop: '-60vh',
                zIndex: 3
            }}>
                <Button style={{
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    position: "absolute",
                    border: '0px solid black',
                    top: '-75px',
                    height: '30px',
                    width: '110px',
                    left: 'calc(50% - 55px)',
                    fontWeight: "bold"
                }}>
                    <span style={{textAlign: "center", fontSize: '14px'}}>ASSIGN<EditOutlined
                        style={{color: "black",}}/></span>
                </Button>
            </Dropdown>
        }


        let boundingHeight = 1080;
        if (notNull(this.gridRef.current)) {
            boundingHeight = (this.gridRef.current || {}).clientHeight - 40;
        }

        return (
            <Spin spinning={this.state.spinning} wrapperClassName={'full-parent'}
                  style={{backgroundColor: "rgba(0,0,0,0)"}}>
                <div className={'full-parent'}
                     style={{backgroundColor: '#03112c'}} ref={this.gridRef}>
                    <Row className={'full-parent'} style={{height: '95%', maxHeight: boundingHeight}}>
                        <div className={'full-parent'} ref={this.boxRef}>
                            {this.props.mode === bloodClass.WBC && editMobile}
                            {this.props.mode === bloodClass.WBC && editMultiple}
                            {annotationsGridParent}
                        </div>
                    </Row>
                    <Row className={'full-parent'} style={{height: '5%', minHeight: 40}}>
                        <Col className={'full-parent'} style={{
                            color: 'white',
                            fontSize: '20px'
                        }}>
                            {gridNumber}
                        </Col>
                    </Row>
                </div>
            </Spin>
        )
    }
}

const mapStateToProps = (state) => {
    let {activeMapId} = state.gammaStateReducer;
    let {slidemap, annotationState} = state.mapsStateReducer[activeMapId];
    return {
        rbcGridData: state.bloodGridRBCReducer,
        pltGridData: state.bloodGridPLTReducer,
        fieldGridData: state.fieldViewReducer,
        wbcGridData: state.wbcViewReducer,
        bloodGridData: state.bloodGridReducer,
        slidemap, annotationState
    };
};

export default connect(mapStateToProps)(BloodGridView);
